import { HTTPInstance } from "@http/http-instance";
import type {
  Allergen,
  Diet,
  Ingredient,
  MenuType,
  SpiceLevel,
  Unit,
} from "./ReferenceAPI.model";

/**
 * Reference lists behind the dish details: allergens, diets, spice levels and
 * units are global, ingredients and menu types are per restaurant.
 *
 * None of them change while a guest is ordering. They used to be memoized here
 * in a module-level map; that job belongs to the query cache now, which dedupes
 * the same way and can also be invalidated, which a plain Map could not.
 */
const get = async <T>(path: string): Promise<T> => {
  const { data } = await HTTPInstance.get<T>(path);
  return data;
};

export const getAllergens = () => get<Allergen[]>("/public/allergens");

export const getDiets = () => get<Diet[]>("/public/diets");

export const getSpiceLevels = () => get<SpiceLevel[]>("/public/spice-levels");

export const getUnits = () => get<Unit[]>("/public/units");

export const getIngredients = (restaurantId: string) =>
  get<Ingredient[]>(`/public/restaurants/${restaurantId}/ingredients`);

export const getMenuTypes = (restaurantId: string) =>
  get<MenuType[]>(`/public/restaurants/${restaurantId}/menu-types`);
